export type UploadStatusType = "pending" | "uploaded" | "not-applicable" | "other";

export interface UploadStatusInfo {
  type: UploadStatusType;
  label: string;
  badgeClass: string;
  rowClass: string;
}

export function getUploadStatusInfo(
  status: string | null | undefined,
): UploadStatusInfo {
  if (!status) {
    return {
      type: "not-applicable",
      label: "—",
      badgeClass: "bg-gray-100 text-gray-500 border border-gray-200",
      rowClass: "",
    };
  }

  if (status === "Ready to Upload") {
    return {
      type: "pending",
      label: "Pending Upload",
      badgeClass: "bg-amber-100 text-amber-800 border border-amber-300",
      rowClass: "bg-amber-50 hover:bg-amber-100",
    };
  }

  if (status.startsWith("Uploaded")) {
    return {
      type: "uploaded",
      label: status,
      badgeClass: "bg-green-100 text-green-800 border border-green-300",
      rowClass: "bg-green-50 hover:bg-green-100",
    };
  }

  return {
    type: "other",
    label: status,
    badgeClass: "bg-gray-100 text-gray-700 border border-gray-200",
    rowClass: "",
  };
}
